export default class UserRole {

    constructor() {
        this.userRoleId = 0;
        this.roleId = 0;
        this.entityId = 0;
        this.occupation = 0;
        this.occupationDesc = '';
        this.expirationDate = '';
        this.conciliation = true;
        this.financialFlow = true;
        this.active = true;
        this.canSignReceipt = false;
    }

}

